<template>
	<el-container>

		<el-header>
			<navbar />
		</el-header>
		
		<el-main>
			<slot/>
		</el-main>

		<el-footer height="60px" class="hidden-xs-only">
			<div>Bilan Patient &copy; <el-link href="https://logiciels-secteurpublic.inetum.com/sp/sdis-regies-centres-de-gestion-vos-solutions-personnalisees" target="_blank" type="primary">SIS a Inetum Software Company</el-link></div>
			<div class="logo-footer"><img src="@/assets/logo_inetum.png"></div>
		</el-footer>

		<el-footer height="15px" class="hidden-sm-and-up">
			<div>Bilan Patient &copy; <el-link href="https://logiciels-secteurpublic.inetum.com/sp/sdis-regies-centres-de-gestion-vos-solutions-personnalisees" target="_blank" type="primary">SIS a Inetum Software Company</el-link></div>
		</el-footer>

	</el-container>
</template>

<script>
import Navbar from '@/components/navbar.component'

export default {
	name: 'BasicLayout',
	components: { Navbar }
}
</script>

<style>
.el-container {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}

.el-header {
	padding: 0;
	position: fixed;
	width: 100%;
	height: 60px;;
	border-bottom: 1px solid #c8ced3;
	z-index: 2;
}
.el-main {
	background-color: #e4e5e6;
	margin-top: 61px;
}

.el-footer {
	border-top: 1px solid #c8ced3;
	background: #f0f3f5;
	flex: 0 0 60px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}

.logo-footer {
	height: 40px;
	margin-left: auto;
	margin-top: 5px;
}
.logo-footer img {
	height: 40px;
}

@media only screen and (max-width:767px) {
	.el-footer, .el-footer .el-link {
		font-size: 80%;
		flex: 0 0 15px;
	}
}
</style>